import * as NotificationActions from './actions/notification.actions';
import{ Notification } from 'src/app/models/notification.model'

export type Action = NotificationActions.All;

//Valor por defecto
const defaultState = {
    contador: 0
}

//Crear nuevo objeto de estado
const newState = (state, newData) => {
    return Object.assign({}, state, newData);
}

export function notificationReducer(state:Notification = defaultState, action: Action){
    switch(action.type){
        case NotificationActions.UPDATE_NOTIFICATION:
            return newState(state, {contador: action.payload});
        default:
            return state;
    }
}